import PropTypes from 'prop-types';
import React from 'react';
import {View, StyleSheet, Text} from 'react-native';
import {Icon} from '../index';
import I18n from '../../../lib/i18n';

const DoughnutContent = props => {
  // Use your theme blue as the fallback
  const THEME_BLUE = "#0000FF";
  let {iconColor, textColor = THEME_BLUE, color = 'white', label} = props;

  if (!props.iconColor) {
    iconColor = textColor;
  }

  const translated = label ? I18n.t('catalog.' + label) : '';

  const isLong = translated.length > 12;

  return (
    <View style={styles.container}>
      <Icon
        name={props.icon}
        size={isLong ? 15 : 20}
        color={iconColor}
        style={styles.icon}
      />
      {label ? (
        <Text
          allowFontScaling={false}
          style={[
            styles.label, 
            {
              color: textColor, 
              fontSize: isLong ? 11 : 13,
              lineHeight: isLong ? 12 : 15
            }
          ]}
        >
          {I18n.t('catalog.' + props.label)}
        </Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 5,
  },
  label: {
    fontWeight: '500',
    textAlign: 'center',
    textTransform: 'none', // Keep it natural for light theme
  },
  icon: {
    marginBottom: 4,
  },
});

export default DoughnutContent;